import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { AddIsland } from './components/AddIsland'
import { EditIsland } from './components/EditIsland'
import { ListIsland } from './components/ListIsland'

const maintenanceBreadCrumbs: Array<PageLink> = [
    {
        title: '',
        path: '/apps/itinerary/add-includes',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

const IslandPage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    path='add-island'
                    element={
                        <>
                            <AddIsland />
                        </>
                    }
                />

                <Route
                    path='edit-island/:id'
                    element={
                        <>
                            <EditIsland />
                        </>
                    }
                />

                <Route
                    path='list-island'
                    element={
                        <>
                            <ListIsland />
                        </>
                    }
                />



                <Route index element={<Navigate to='/apps/landing/add-island' />} />
            </Route>
        </Routes>
    )
}

export default IslandPage
